import { atlas } from '~/services/serviceInstances';

import { Guideline } from '../../types/playbooks/guidelines';

export const createGuideline = async (
  data: Guideline,
): Promise<{ data: { uuid: string } }> => {
  return atlas.post('guidelines', {
    data: {
      type: 'guideline',
      attributes: data,
    },
  });
};
